// extracted by mini-css-extract-plugin
export default {"container":"J70oiooiLXdk_M10ZcYG"};